/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RegistrationType {
  MOTOR_CARRIER = 'motor_carrier',
  BROKER = 'broker',
  INSURANCE_PROVIDER = 'insurance_provider',
}
